const truncateDataLabel = (data: Array<string>): string => {
  let dataLabel = "";
  if (data.length > 0 && data[0] != null) {
    dataLabel += ` ${data[0]}`;
  }
  if (data.length > 1) {
    dataLabel += `, +${data.length - 1} more`;
  }
  return dataLabel;
};

interface ChipLabelProps {
  column: string;
  operation: string;
  data: string | Array<string>;
}

export const ChipLabel = ({ column, operation, data }: ChipLabelProps) => {
  return (
    <span className="text-sm">
      {column} <span className="text-sm text-gray-600">{operation}</span>
      {Array.isArray(data) ? truncateDataLabel(data) : data}
    </span>
  );
};
